import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-323df528"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Вход в систему", -1))
const _hoisted_3 = { class: "new-user" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Новый пользователь?", -1))
const _hoisted_5 = { class: "auth-form-components" }
const _hoisted_6 = { class: "flex flex-col input-labeled" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "E-mail", -1))
const _hoisted_8 = { class: "flex flex-col input-labeled" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Пароль", -1))
const _hoisted_10 = {
  key: 0,
  class: "bad-msg"
}
const _hoisted_11 = {
  key: 1,
  class: "bad-msg"
}
const _hoisted_12 = {
  key: 0,
  class: "after-info"
}
const _hoisted_13 = { class: "forgot" }
const _hoisted_14 = { class: "policy" }
const _hoisted_15 = {
  key: 1,
  class: "fl-senter m-t-5"
}

import { ref } from "vue";

import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { getCurrentDomain } from "@/services/utils/Domain";

import InputText from "primevue/inputtext";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Password from "primevue/password";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  setup(__props) {

const domain = getCurrentDomain();

const authStore = useAuthStore();
const router = useRouter();
const isProgress = ref(false);
const crendetails = ref({
  username: "",
  password: "",
});
const invalid = ref(false);

function login() {
  if (crendetails.value.password && crendetails.value.username) {
    isProgress.value = true;
    localStorage.removeItem("access_token");
    invalid.value = false;

    authStore
      .login(crendetails.value)
      .then(async () => {
        await authStore.getUserInfo();
        const startPage = authStore.getStartPage();
        router.push(
          router.currentRoute.value.query.next?.toString() || startPage
        );
      })
      .catch(() => {
        invalid.value = true;
      })
      .finally(() => {
        isProgress.value = false;
      });
  } else {
    invalid.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_router_link, { to: { name: 'signup' } }, {
        default: _withCtx(() => [
          _createTextVNode("Создать учетную запись")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_unref(InputText), {
          id: "username",
          modelValue: crendetails.value.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((crendetails.value.username) = $event)),
          "aria-describedby": "username-help",
          placeholder: "Введите e-mail или номер телефона",
          invalid: invalid.value
        }, null, 8, ["modelValue", "invalid"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_unref(Password), {
          id: "password",
          modelValue: crendetails.value.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((crendetails.value.password) = $event)),
          placeholder: "Введите пароль",
          feedback: false,
          invalid: invalid.value
        }, null, 8, ["modelValue", "invalid"])
      ]),
      (invalid.value && crendetails.value.password && crendetails.value.username)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Неправильный логин или пароль "))
        : (invalid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Заполните все поля формы"))
          : _createCommentVNode("", true),
      _createVNode(_unref(Button), {
        label: "Войти",
        class: "form-button",
        onClick: login,
        disabled: isProgress.value
      }, null, 8, ["disabled"])
    ]),
    (_unref(domain).includes('dvgroup.com'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, { to: { name: 'resetPassword' } }, {
              default: _withCtx(() => [
                _createTextVNode("Забыли пароль?")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createTextVNode(" Нажимая на кнопку «Войти» вы принимаете "),
            _createVNode(_component_router_link, { to: { name: 'privacyPolicy' } }, {
              default: _withCtx(() => [
                _createTextVNode("условия пользовательского соглашения")
              ]),
              _: 1
            }),
            _createTextVNode(" и "),
            _createVNode(_component_router_link, { to: { name: 'personalDataPolicy' } }, {
              default: _withCtx(() => [
                _createTextVNode("разрешаете обработку персональных данных")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (isProgress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_unref(ProgressSpinner), {
            "aria-label": "Loading",
            style: {"width":"30px","height":"30px"},
            strokeWidth: "2",
            fill: "var(--surface-ground)"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})